import styled from 'styled-components';

export const SamplePage = () => {
  return (
    <Container>
      <h1>This is SamplePage.</h1>
    </Container>
  );
};

const Container = styled.div`
  background-color: pink;
`;
